.form-locations-table-container > :first-child {
    /* 1px offset for border that causes scroll */
    width: calc(100% - 1px) !important;
}

.custom-cell-header {
    display: flex;
    align-items: center;
}
